import { useContext, useMemo } from 'react';
import moment from 'moment';
// import { isArray } from 'lodash';
import { DataContext } from '../context/data-context';
import {
  getCurrentMatchesWithWholeDays,
  getCurrentMatchDate,
} from '../utils/matches';
import { useApi } from './api';

export const useCurrentMatchesTeam = (abbrv) => {
  // const [data, loading, error] = useApi(`team/current-matches?id=${abbrv}`);
  const [data, loading, error] = useApi(`team/all-matches?id=${abbrv}`);

  const limit = 5;
  const matches = useMemo(() => {
    const allMatches = [...(data || [])].reverse();
    const sinceYesterday = allMatches
      .filter((match) => {
        return moment(match.startDate).isSameOrAfter(
          moment().subtract(1, 'days').startOf('day')
        );
      })
      .slice(0, limit)
      .reverse();
    if (sinceYesterday.length === limit) {
      return sinceYesterday;
    }
    if (sinceYesterday.length) {
      const [firstMatch] = sinceYesterday;

      const additionalMatches = allMatches
        .filter((match) => {
          return moment(match.startDate).isBefore(
            moment(firstMatch.startDate).startOf('day')
          );
        })
        .slice(0, limit - sinceYesterday.length)
        .reverse();

      return [...additionalMatches, ...sinceYesterday];
    }

    return [...allMatches].slice(0, limit).reverse();
  }, [data]);

  return [matches, loading, error];
};

export const useAllMatchesTeam = (abbrv) =>
  useApi(`team/all-matches?id=${abbrv}`);

export const useCurrentMatches = () => {
  const [data, loading, error] = useApi('current-matches');
  const [data2, loading2, error2] = useApi('qualification-matches');
  const matches = useMemo(
    () =>
      data && data2
        ? getCurrentMatchesWithWholeDays(
            [...(data?.length ? data : []), ...(data2?.length ? data2 : [])],
            8,
            2,
            10
          )
        : [],
    [data, data2]
  );

  return [matches, loading || loading2, error || error2];
};

function withFakeStatus(matches) {
  const dateParam = new URLSearchParams(window.location.search).get(
    'matchDate'
  );

  if (dateParam) {
    return matches?.map((match) => {
      const status =
        moment(match.startDate).isBefore(dateParam) &&
        moment(match.startDate).add(90, 'minutes').isAfter(dateParam)
          ? 'ONGOING'
          : match.status;
      return {
        ...match,
        status,
        matchMinuteWithStoppageTime:
          status === 'ONGOING'
            ? moment(dateParam).diff(match.startDate, 'minutes').toString()
            : match.matchMinuteWithStoppageTime,
      };
    });
  }

  return matches;
}

export const useMatchesMinimized = (season) => {
  const [matches, loading, error] = useApi(
    `match-list/minimized?season=${season}`
  );

  return [withFakeStatus(matches), loading, error];
};

export const useMatchesToday = () => {
  const { currentSeason } = useContext(DataContext);
  const [matches, loading, error] = useMatchesMinimized(currentSeason);

  const matchDate = getCurrentMatchDate();

  const matchesToday = useMemo(() => {
    return withFakeStatus(
      matches?.filter((match) =>
        moment(match.startDate).isSame(matchDate, 'day')
      )
    );
  }, [matches, matchDate?.hour()]);

  return [matchesToday, loading, error];
};

export const useLatestHighlights = () => {
  const { league, currentSeason } = useContext(DataContext);
  const [data, loading, error] = useApi(
    `latest-highlights?league=${league}&season=${currentSeason}`
  );

  const matchDate = getCurrentMatchDate();

  const highlights = useMemo(
    () =>
      data?.some(
        (h) => matchDate && moment(h.video.date).isSame(matchDate, 'day')
      )
        ? data
        : null,
    [data, matchDate.hour()]
  );

  return [highlights, loading, error];
};
